import { MainGrid } from './MainGrid';
import './grid-styles.css';

export const ReportSection = ({ title, gridData, onOpenModal }) => {
  return ( 
    <div className="report-section">
      <div className="section-header">
        <h4>{title}</h4>
      </div>
      <MainGrid headers={gridData.headers} rows={gridData.rows} onOpenModal={onOpenModal} />
    </div> 
  );
};
